import { Box, Container, Tooltip, Typography } from "@mui/material";
import React from "react";
import { zim } from "../../assets/images";

const HeroSection = () => {
  const locations = [
    { id: 1, top: "33%", left: "79.6%", label: "Marondera" },
    { id: 2, top: "60%", left: "40.5%", label: "Bulawayo" },
    { id: 3, top: "67%", left: "43.5%", label: "Matopos" },
  ];

  return (
    <Box
      sx={{
        width: "100vw",
        height: { md: "100vh" },
        py: { xs: 5, md: 5 },
        pt: { xs: 5, md: 5 },
        backgroundColor: "secondary.main",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", md: "column-reverse" },
          justifyContent: { xs: "center", md: "center" },
          alignItems: "center",
          height: { xs: "100vh", md: "inherit" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: 558 },
            height: {xs: "315px", md: "510px"},
            position: "relative",
            backgroundImage: `url(${zim})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            mt: {xs: 5, md: 0}
          }}
        >
          {locations.map((loc) => (
            <Tooltip key={loc.id} title={loc.label} arrow>
              <Box
                sx={{
                  position: "absolute",
                  top: loc.top,
                  left: loc.left,
                  width: {xs: 10, md: 20},
                  height: {xs: 10, md: 20},
                  backgroundColor: "primary.main",
                  borderRadius: "50%",
                  cursor: "pointer",
                  transition: "transform 0.2s ease",
                  "&:hover": {
                    transform: "scale(1.3)",
                  },
                }}
                onMouseEnter={() => console.log(`Hovered on ${loc.label}`)}
              />
            </Tooltip>
          ))}
        </Box>
        <Typography
          variant="h1"
          sx={{
            width: { sx: "100%", md: "100%" },
            fontSize: { xs: "1.5rem", md: "2.0rem" },
            textAlign: "center",
            mb: { md: 5 },
          }}
          color="primary.dark"
        >
          We create opportunities for{" "}
          <span style={{ color: "#DB5430" }}>children and youth</span> across
          Africa to embark on{" "}
          <span style={{ color: "#DB5430" }}>holistic learning journeys</span>{" "}
          that are relevant and accessible, empowering learners to be{" "}
          <span style={{ color: "#DB5430" }}>
            curious, courageous and caring contributors
          </span>{" "}
          within the community.
        </Typography>
      </Container>
    </Box>
  );
};

export default HeroSection;
